import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { RowMouseEventHandlerParams } from 'react-virtualized';
import { useDebounce } from '../../../../../../../_metronic/helpers';
import InputSearch from '../../../../../component/InputSearch';
import SimpleTable from '../../../../../component/table/simple-table/SimpleTable';
import { CODE_DOI_TUONG } from '../../../../../phan-he-tiep-nhan-thanh-toan/constants/PhanHeTiepNhan';
import { formatMoney } from '../../../../../utils/FormatUtils';
import { getListVatTu } from '../../common';
import { useKeVatTuContext } from '../../context';
import { useTableSelectVatTuContext } from '../../context/TableSelectVatTuContext';
import TableSelectVatTuRowEdit from './TableSelectVatTuRowEdit';
import { LOAI_VAT_TU } from '../../../../../phan-he-kham-benh/constants/VatTu';
import { WAREHOUSE } from '../../../../../phan-he-kham-benh/constants/Thuoc';
import { columnsKeVatTu } from '../../../../../phan-he-kham-benh/columns/modal-ke-vat-tu/ColumnModalKeVatTu';
import { usePhanHeDieuTriNoiTruContext } from '../../../../PhanHeDieuTriContext';
import { getPriceByObjectType } from '../../../../../phan-he-kham-benh/modals/modal-ke-thuoc/utils';

const TableSelectVatTu = () => {
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
	const { treeNodeValue, setVatTuChecked, vatTuChecked, treeValue, selectedNode } =
		useKeVatTuContext();
	const { selectedRow, setSelectedRow, editRowIndex, setEditRowIndex } =
		useTableSelectVatTuContext();

	const tableDataRef = useRef<any[]>([]);
	const [tableData, setTableData] = useState<object[]>([]);
	const [query, setQuery] = useState<string>('');
	const queryDebounce = useDebounce(query.trim(), 700);

	useEffect(() => {
		setTableData(treeNodeValue);
		tableDataRef.current = treeNodeValue;
	}, [treeNodeValue]);

	useEffect(() => {
		onSearchVatTu(queryDebounce);
	}, [queryDebounce]);
	
	console.log(selectedNode);
	
	const onSearchVatTu = async (query?: string) => {
		if (!treeValue) return;

		const result = await getListVatTu({
			materialType: selectedNode?.code ?? tableDataRef.current?.[0]?.materialType,
			warehouseId: treeValue.id,
			materialGroup: LOAI_VAT_TU.VAT_TU,
			keyword: query,
		});
		setTableData(result ?? []);
	};

	const onSearch = async (e: ChangeEvent<HTMLInputElement>) => {
		const keySearch = e.target.value;
		setQuery(keySearch);

		if (!keySearch) {
			setTableData(tableDataRef.current);
			return;
		}
	};

	const renderCell = (columnData: any, dataKey: string, rowData: any) => {
		rowData = {
			...rowData,
			tonKho: formatMoney(rowData?.tonKho) || 0,
			giaBhyt: formatMoney(rowData?.bhytPrice) || 0,
			giaVienPhi: formatMoney(rowData?.hospitalPrice) || 0,
			giaDichVu: formatMoney(rowData?.servicePrice) || 0,
		};
		if (typeof rowData.get === 'function') {
			return rowData.get(dataKey);
		} else {
			return rowData[dataKey];
		}
	};

	const onRowSelect = (rows: any[]) => {
		const rowData = rows[0];
		const isExistVatTu = vatTuChecked.some(
			(row) =>
				row.idVatTu?.toString() === rowData.id?.toString() &&
				row?.consignment === rowData?.consignment
		);
		if (isExistVatTu) {
			toast.warn('Vật tư đã được kê trong phiếu chỉ định');
			return;
		} else {
			setSelectedRow(rowData);
		}
	};
	
	const onSaveSelectedRow = (values: any) => {
		const isKhoNhaThuoc = WAREHOUSE.PHARMACY.ID === treeValue?.id;
		const donGiaVatTu =
			(isKhoNhaThuoc
				? values.giaBan
				: getPriceByObjectType(
						values,
						values.objectTypeCode ?? benhNhanDieuTri?.visitObjectTypeCode
				  )) || values.donGia;
		let listTemp = [...vatTuChecked];

		const additonalRowData = {
			...values,
			donGia: donGiaVatTu,
			thanhTien: donGiaVatTu * values.soLuong,
			doiTuong: values.doiTuong || benhNhanDieuTri?.visitObjectTypeName,
			objectTypeId: values?.objectTypeId ?? benhNhanDieuTri?.visitObjectTypeId,
			objectTypeCode: values?.objectTypeCode ?? benhNhanDieuTri?.visitObjectTypeCode,
			objectTypeName: values?.objectTypeName ?? benhNhanDieuTri?.visitObjectTypeName,
		};

		if (editRowIndex !== null) {
			listTemp = vatTuChecked.map((row: any) => {
				if (row.index === editRowIndex) {
					return {
						idVatTu: values.id,
						...additonalRowData,
					};
				}
				return row;
			});
			setEditRowIndex(null);
		} else {
			listTemp = [
				...listTemp,
				{
					idVatTu: values.id,
					...additonalRowData,
				},
			];
		}

		setVatTuChecked(listTemp.map((row, index) => ({ ...row, index })));
		setSelectedRow(null);
	};

	return (
		<>
			<div className="bg-white">
				<div className="px-3 py-1">
					<TableSelectVatTuRowEdit data={selectedRow} onSave={onSaveSelectedRow} />
				</div>
				<div className="spaces mb-4">
					<InputSearch
						placeholder="Tìm kiếm"
						handleChange={onSearch}
						className="spaces h-30"
					/>
				</div>
				<div className="min-h-180 spaces bg-white mb-6">
					<SimpleTable
						data={tableData}
						columns={columnsKeVatTu}
						height={200}
						width={1000}
						scrollable={true}
						setDataChecked={onRowSelect}
						handleRenderCell={renderCell}
						dataChecked={selectedRow ? [selectedRow] : []}
						onRowClick={({ rowData }: RowMouseEventHandlerParams) => {
							onRowSelect([rowData]);
						}}
						subPrefix="consignment"
					/>
				</div>
			</div>
		</>
	);
};

export default TableSelectVatTu;
